import { database } from './../../firebase/firebase-app';

export const listenToOrders = () => {
  return (dispatch, getState) => {
    const customerCode = getState().customer.code;
    const ordersRef = database.ref('orders/' + customerCode);
    ordersRef.once('value')
      .then( snapshot => {
        dispatch({
          type: 'RECEIVE_ORDERS',
          p: snapshot.val()
        });
        dispatch({
          type: 'SET_LOADING',
          p: { orders: true }
        });
      })
      .catch( error => {
        dispatch({
          type: 'RECEIVE_ORDERS_ERROR',
          p: error.message
        });
      });
  };
};

const orderConditionsValid = (conditions, sets) => {
  let valid = true;
  if (conditions.requestedDelivDate === '') {
    valid = false;
  };
  if (conditions.qty === 0) {
    valid = false;
  }
  const sum = conditions.paymentConditions.reduce((res, val) => res + val.percent , 0);
  if (sum !== 100) {
    valid = false;
  };
  conditions.paymentConditions.map(condition => {
    if (condition.percent > 0 && (condition.val === '' || condition.val === 0)) {
      valid = false;
    }
    return null;
  });
  // validate options
  if (conditions.setId) {
    const set = sets[conditions.setId];
    if (set.options) {
      Object.keys(set.options).map( key => {
        if (!conditions.selectedOptions[key]) {
          valid = false;
        }
        return null;
      })
    }
  };
  return valid;
};

export const createOrder = ({ date = (new Date()).toLocaleDateString(), accessories = undefined } = {} ) => {
  return (dispatch, getState) => {
    const customerCode = getState().customer.code;
    const orderConditions = getState().ui.orderConditions;
    const { paymentConditions, requestedDelivDate, comment} = orderConditions;
    if (orderConditionsValid(orderConditions, getState().sets)) {
      let newOrder = database.ref('orders/' + customerCode).push();
      const type = accessories ? 'a' : 'm';
      let requested;
      if (accessories) {
        requested = accessories;
      } else {
        requested = { [orderConditions.setId]: orderConditions.qty };
      }
      newOrder.set({
        id: newOrder.key,
        type,
        status: 0,
        date,
        requestedDelivDate,
        comment,
        requested,
        paymentConditions,
        selectedOptions: orderConditions.selectedOptions || null
        // userId,
      }, () => {
        dispatch({ type: 'SET_ORDER_SET_ID', p: '' });
        dispatch({ type: 'SET_SCREEN', name: 'setCard', val: false });
        dispatch({ type: 'SET_SCREEN', name: 'modelSets', val: false });
        dispatch({ type: 'SET_SCREEN', name: 'categoryData', val: false });
        dispatch({ type: 'SET_MAIN_SCREEN_PAGE', p: 'orders' });
        dispatch(listenToOrders());
      });
      database.ref('orders-ids/' + newOrder.key).set(customerCode);
    } else {
      dispatch({ type: 'SET_ORDER_VALIDATION_MODE' });
    }

  }
}

// service

export const getOrdersIds = customerCode => {
  const ordersRef = database.ref('orders/' + customerCode);
  return ordersRef.once('value')
    .then( snapshot => {
      return snapshot.val();
    })
}



// WEBPACK FOOTER //
// ./src/actions/firebase/orders.js